(function () {
  const { publicPath } = window.appConfig;

  if (publicPath) {
    __webpack_public_path__ = publicPath;
  }
})();
